<template>
  <a-modal
    title="新增处方退药"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="处方id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入处方id" v-decorator="['recipeId', {rules: [{required: true, message: '请输入处方id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="订单id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入订单id" v-decorator="['orderId', {rules: [{required: true, message: '请输入订单id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="患者id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入患者id" v-decorator="['personId', {rules: [{required: true, message: '请输入患者id！'}]}]" />
        </a-form-item>
        <a-form-item
          label="状态 0：审核中  1：审核通过  2：审核驳回  3：二次审核中  4：二次审核通过  5：二次审核驳回  6：已退费"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入状态 0：审核中  1：审核通过  2：审核驳回  3：二次审核中  4：二次审核通过  5：二次审核驳回  6：已退费" v-decorator="['status', {rules: [{required: true, message: '请输入状态 0：审核中  1：审核通过  2：审核驳回  3：二次审核中  4：二次审核通过  5：二次审核驳回  6：已退费！'}]}]" />
        </a-form-item>
        <a-form-item
          label="退库存状态  0：未退库存  1：已退库存"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入退库存状态  0：未退库存  1：已退库存" v-decorator="['returnStockStatus', {rules: [{required: true, message: '请输入退库存状态  0：未退库存  1：已退库存！'}]}]" />
        </a-form-item>
        <a-form-item
          label="退药原因"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入退药原因" v-decorator="['returnReason', {rules: [{required: true, message: '请输入退药原因！'}]}]" />
        </a-form-item>
        <a-form-item
          label="驳回原因"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入驳回原因" v-decorator="['rejectReason', {rules: [{required: true, message: '请输入驳回原因！'}]}]" />
        </a-form-item>
        <a-form-item
          label="驳回时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择驳回时间" v-decorator="['rejectTime',{rules: [{ required: true, message: '请选择驳回时间！' }]}]" @change="onChangerejectTime"/>
        </a-form-item>
        <a-form-item
          label="二次驳回原因"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入二次驳回原因" v-decorator="['secondRejectReason', {rules: [{required: true, message: '请输入二次驳回原因！'}]}]" />
        </a-form-item>
        <a-form-item
          label="二次驳回时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择二次驳回时间" v-decorator="['secondRejectTime',{rules: [{ required: true, message: '请选择二次驳回时间！' }]}]" @change="onChangesecondRejectTime"/>
        </a-form-item>
        <a-form-item
          label="创建时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-date-picker style="width: 100%" placeholder="请选择创建时间戳" v-decorator="['ctstamp',{rules: [{ required: true, message: '请选择创建时间戳！' }]}]" @change="onChangectstamp"/>
        </a-form-item>
        <a-form-item
          label="更新时间戳"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
        </a-form-item>
        <a-form-item
          label="使用标志（1-启用0-停用）"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
        >
          <a-input placeholder="请输入使用标志（1-启用0-停用）" v-decorator="['useflag', {rules: [{required: true, message: '请输入使用标志（1-启用0-停用）！'}]}]" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { buRecipeReturnDrugAdd } from '@/api/modular/interhospital/burecipereturndrug/buRecipeReturnDrugManage'
  export default {
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 15 }
        },
        rejectTimeDateString: '',
        secondRejectTimeDateString: '',
        ctstampDateString: '',
        visible: false,
        confirmLoading: false,
        form: this.$form.createForm(this)
      }
    },
    methods: {
      // 初始化方法
      add (record) {
        this.visible = true
      },
      /**
       * 提交表单
       */
      handleSubmit () {
        const { form: { validateFields } } = this
        this.confirmLoading = true
        validateFields((errors, values) => {
          if (!errors) {
            for (const key in values) {
              if (typeof (values[key]) === 'object') {
                values[key] = JSON.stringify(values[key])
              }
            }
            values.rejectTime = this.rejectTimeDateString
            values.secondRejectTime = this.secondRejectTimeDateString
            values.ctstamp = this.ctstampDateString
            buRecipeReturnDrugAdd(values).then((res) => {
              if (res.success) {
                this.$message.success('新增成功')
                this.confirmLoading = false
                this.$emit('ok', values)
                this.handleCancel()
              } else {
                this.$message.error('新增失败')// + res.message
              }
            }).finally((res) => {
              this.confirmLoading = false
            })
          } else {
            this.confirmLoading = false
          }
        })
      },
      onChangerejectTime(date, dateString) {
        this.rejectTimeDateString = dateString
      },
      onChangesecondRejectTime(date, dateString) {
        this.secondRejectTimeDateString = dateString
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      handleCancel () {
        this.form.resetFields()
        this.visible = false
      }
    }
  }
</script>
